function customProductMediaSliderInit() {
  const sliders = document.querySelectorAll(".product-media-carousel");
  if (!sliders.length) return;

  sliders.forEach((sliderEl) => {
    new Swiper(sliderEl, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        nextEl: sliderEl.querySelector(".swiper-button-next"),
        prevEl: sliderEl.querySelector(".swiper-button-prev"),
      },
      keyboard: {
        enabled: true,
      },
    });
  });
}

customProductMediaSliderInit();

  
